import React, { Component } from "react";
import styles from "./Popup.module.scss";
import Wrapper from "../../hoc/Wrapper/Wrapper";
import { withRouter } from "react-router-dom";
import Button from "../UI/Button/Button";
import copy from "../../assets/copy/copy.json"
import { Dropdown, DropdownItem, DropdownMenu } from "semantic-ui-react";
import Icon from "../UI/Icon/Icon";
import { Requests } from "../../api/IdentityServerRequests/Requests";

var classNames = require("classnames");

class SetThresholdModal extends Component {
  constructor(props) {
    super(props);
    const activeQualifications = props.modifiedThresholds
    
    const defaultQualification = {
      name: "Any member",
      code: 0,
      threshold: 0
    }

    this.state = {
      qualificationThresholds: activeQualifications?.length ? activeQualifications : [defaultQualification]
    };
    this.Requests = new Requests();
  }

  addThreshold = () => {
    const newThreshold = {
      name: "Any member",
      code: 0,
      threshold: 1
    }
    const newThresholds = this.state.qualificationThresholds.concat(newThreshold)
    this.setState({ qualificationThresholds: newThresholds })
  }

  setThresholdTypeAtIndex = (qual, index) => {
    const thresholds = this.state.qualificationThresholds
    const thresholdAtIndex = thresholds[index]
    thresholdAtIndex.code = qual.key
    thresholdAtIndex.name = qual.value
    thresholds[index] = thresholdAtIndex
    this.setState({ qualificationThresholds: thresholds })
  }

  setThresholdQuantityAtIndex = (quantity, index) => {
    const thresholds = this.state.qualificationThresholds
    const thresholdAtIndex = thresholds[index]
    thresholdAtIndex.threshold = quantity
    thresholds[index] = thresholdAtIndex
    this.setState({ qualificationThresholds: thresholds })
  }

  removeThresholdAtIndex = (index) => {
    const thresholds = this.state.qualificationThresholds
    if (thresholds.length > 1) {
      const newThresholds = thresholds.slice(0, index).concat(thresholds.slice(index + 1))
      this.setState({ qualificationThresholds: newThresholds })
    }
  }

  applyThresholds = () => {
    const payload = {
      anyMembers: 0,
      qualificationThresholds: []
    }
    const qualificationThresholds = this.state.qualificationThresholds
      .filter(t => t.code !== 0)
      .map((t, i) => {
        return({
          qualificationId: t.code,
          thresholdCount: t.threshold,
          presentationOrder: i
        })
      })
    const anyMembers = this.state.qualificationThresholds
      .filter(t => t.code === 0)[0]
    payload.qualificationThresholds = qualificationThresholds
    payload.anyMembers = anyMembers?.threshold || 0

    // call API
    const API_ENDPOINT = this.Requests.setQualificationThresholds
    this.Requests.callAPI(API_ENDPOINT, this.props.pagingNumber, payload).then((data) => {
      if (data?.status === 200) {
        this.props.onClose();
      } else {
        this.props.onClose();
      }
    })
  }

  render() {
    if (this.props.isVisible) {
      document.body.classList.add("popup-mode");
    } else {
      document.body.classList.remove("popup-mode");
    }

    let CloseAlertControls = classNames(
      "tileBg2 " + styles.closeAlertControls,
      this.props.className,
      {
        [styles.visible]: this.props.isVisible,
      },
      styles.viewbyModalClass
    );

    let DarkMask = classNames(styles.darkMask, this.props.className, {
      [styles.visible]: this.props.isVisible,
    });

    const totalCount = this.state.qualificationThresholds.reduce((acc, current) => acc + current.threshold, 0)
    const disabled = this.state.qualificationThresholds.length >= 10

    return (
      <Wrapper>
        <div>
          <div className={CloseAlertControls}>
            <div className={styles.content}>
              <div className={styles.spanButtons + " " + styles.paddingOnly}>
                <span>{"Set threshold"}</span>
                <button
                  className="closeAlertControls__btn -close"
                  onClick={this.props.onClose}
                >
                </button>
              </div>
              <div className={styles.listItem + " " + styles.leftAlign + " " + styles.noBorders}>
                <div className={styles.labelLeft}>Qualifications threshold:</div>
                <div className={styles.labelRight}>{totalCount}</div>
              </div>
              <div id="listContainer" className={styles.listContainer}>
                {this.state.qualificationThresholds.map((threshold, index) => {
                  const qualificationDropdownButton = <Button
                    content={threshold.name}
                    key={threshold.code}
                    styles="threshold"
                    variant="btn_thresholdButs"
                    icon="icon_arrowDownSmall"
                  />
                  const quantityButton = <Button
                    content={threshold.threshold}
                    styles="quantity"
                    variant="btn_thresholdButs"
                    icon="icon_arrowDownSmall"
                  />
                  return (
                    <div key={`dropdownRow${index}`} className={styles.listItem + " " + styles.noBorders}>
                      <Dropdown
                        trigger={qualificationDropdownButton}
                        icon={null}
                      >
                        <DropdownMenu
                          className={styles.scrollingDropdownMenu + " " + styles.left}
                        >
                          {this.props.qualifications?.map(qual => {
                            return (
                              <DropdownItem
                                className={styles.dropdownItem + " " + styles.wide}
                                text={qual.value}
                                key={qual.key}
                                onClick={() => this.setThresholdTypeAtIndex(qual, index)}
                              />
                            )
                          })}
                        </DropdownMenu>
                      </Dropdown>
                      <div>Qty:</div>
                      <Dropdown
                        trigger={quantityButton}
                        icon={null}
                      >
                        <DropdownMenu
                          className={styles.scrollingDropdownMenu + " " + styles.right}
                        >
                          {[...Array(10).keys()].map(n => {
                            return (
                              <DropdownItem
                                className={styles.dropdownItem}
                                text={n}
                                key={n}
                                onClick={() => this.setThresholdQuantityAtIndex(n, index)}
                              />
                            )
                          })}
                        </DropdownMenu>
                      </Dropdown>
                      <div
                        onClick={() => this.removeThresholdAtIndex(index)}
                      >
                        <Icon
                          icon="icon_remove"
                        />
                      </div>
                    </div>
                  )
                })}
                <div className={styles.listItem + " " + styles.rightAlign + " " + styles.noBorders}>
                  <Button
                    variant="btn_thresholdButs"
                    styles={`addThreshold + ${disabled && " disabled"}`}
                    content="Add another threshold"
                    disabled={disabled}
                    icon="icon_add_availability_grey"
                    buttonClick={this.addThreshold}
                  />
                </div>
              </div>
              <div className={styles.bottomButtonContainer + " " + styles.topPadding + " " + styles.topBorder}>
                <Button
                  label="Back"
                  buttonClick={this.props.backButton}
                  content="Back"
                  variant="btn_secondary"
                  styles="footerButton"
                ></Button>
                <Button
                  label="Save"
                  buttonClick={this.applyThresholds}
                  content="Save"
                  variant="btn_secondary"
                  styles="footerButton saveBtnStyle"
                ></Button>
              </div>
            </div>
          </div>
          <div className={DarkMask} />
        </div>
      </Wrapper>
    );
  }
}

export default withRouter(SetThresholdModal);
